// 'canopy' is a deprecated tier kept here so legacy DB rows still type-check.
// New orgs cannot select it; trial endpoint rejects it.
export type SubscriptionTier = 'seedling' | 'sapling' | 'sprout' | 'canopy' | 'forest';

const TIER_ORDER: SubscriptionTier[] = ['seedling', 'sapling', 'sprout', 'canopy', 'forest'];

export function tierAtLeast(
  current: SubscriptionTier | undefined,
  required: SubscriptionTier
): boolean {
  if (!current) return false;
  return TIER_ORDER.indexOf(current) >= TIER_ORDER.indexOf(required);
}

export const FEATURE_MIN_TIER = {
  media: 'sapling',
  analytics: 'sprout',
  multisite: 'forest',
} as const;

export function canUseFeature(
  current: SubscriptionTier | undefined,
  feature: keyof typeof FEATURE_MIN_TIER
): boolean {
  return tierAtLeast(current, FEATURE_MIN_TIER[feature]);
}
